(()=>{
  'use strict';
  document.querySelectorAll('[data-re-hub]').forEach(root=>{
    if(root.dataset.ready)return;
    const search=root.querySelector('[data-re-search-input]');
    const select=root.querySelector('[data-re-select]');
    const filters=[...root.querySelectorAll('[data-re-filter]')];
    const panels=[...root.querySelectorAll('[data-re-panel]')];
    const budgetList=root.querySelector('[data-re-panel="budgets"] ul');
    if(budgetList){const amount=item=>{const text=item.querySelector('strong').textContent;return parseFloat(text.replace(/[$,]/g,''))*(text.includes('million')?1000000:1)};[...budgetList.children].sort((a,b)=>amount(a)-amount(b)).forEach(item=>budgetList.append(item))}
    let items=[...root.querySelectorAll('[data-re-item]')];
    const more=root.querySelector('[data-re-more]');
    const clear=root.querySelector('[data-re-clear]');
    const status=root.querySelector('[data-re-status]');
    const empty=root.querySelector('[data-re-empty]');
    if(!search||!select||!items.length)return;
    let category='comparisons',limit=9;
    const clean=s=>s.normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
    function indexItems(){items=[...root.querySelectorAll('[data-re-item]')];items.forEach(item=>item.dataset.search=clean(item.dataset.reSearch||item.textContent));filters.forEach(button=>{const count=items.filter(item=>item.dataset.reCategory===button.dataset.reFilter).length;button.querySelector('small').textContent=String(count)})}
    indexItems();
    function render(){
      const words=clean(search.value).split(' ').filter(Boolean);
      const searching=words.length>0;
      const matched=items.filter(item=>(searching||item.dataset.reCategory===category)&&words.every(word=>item.dataset.search.includes(word)));
      const visible=new Set(matched.slice(0,limit));
      items.forEach(item=>item.hidden=!visible.has(item));
      panels.forEach(panel=>panel.hidden=searching?![...panel.querySelectorAll('[data-re-item]')].some(item=>visible.has(item)):panel.dataset.rePanel!==category);
      filters.forEach(button=>button.setAttribute('aria-pressed',String(!searching&&button.dataset.reFilter===category)));
      select.value=searching?'search':category;
      more.hidden=matched.length<=limit;
      clear.hidden=search.value.length===0;
      empty.hidden=matched.length>0;
      status.textContent=root.dataset.reCount.replace('{shown}',String(Math.min(limit,matched.length))).replace('{total}',String(matched.length));
    }
    function choose(value){if(value==='search')return;category=value;search.value='';limit=9;render()}
    filters.forEach((button,index)=>{
      button.addEventListener('click',()=>choose(button.dataset.reFilter));
      button.addEventListener('keydown',event=>{
        let target;
        if(event.key==='ArrowRight')target=(index+1)%filters.length;
        if(event.key==='ArrowLeft')target=(index+filters.length-1)%filters.length;
        if(event.key==='Home')target=0;
        if(event.key==='End')target=filters.length-1;
        if(target!==undefined){event.preventDefault();filters[target].focus();choose(filters[target].dataset.reFilter)}
      });
    });
    select.addEventListener('change',()=>choose(select.value));
    search.addEventListener('input',()=>{limit=9;render()});
    more.addEventListener('click',()=>{const shown=items.filter(item=>!item.hidden).length;limit+=9;render();const next=items.filter(item=>!item.hidden)[shown];if(next&&more.hidden)next.querySelector('a').focus()});
    clear.addEventListener('click',()=>{search.value='';limit=9;render();search.focus()});
    root.querySelectorAll('[data-re-controls]').forEach(control=>control.hidden=false);
    root.dataset.ready='true';render();
    async function completeCatalog(){
      let next=root.dataset.reNext;
      const known=new Set(items.map(item=>item.querySelector('a').getAttribute('href')));
      const visited=new Set();
      while(next){
        const url=new URL(next,location.href);
        if(url.origin!==location.origin||visited.has(url.href))return;
        visited.add(url.href);url.searchParams.set('section_id',root.dataset.reSection);
        const view=new URL(location.href).searchParams.get('view');if(view)url.searchParams.set('view',view);
        try{
          const response=await fetch(url,{credentials:'same-origin'});if(!response.ok)return;
          const doc=new DOMParser().parseFromString(await response.text(),'text/html');
          const incoming=doc.querySelector('[data-re-hub]');if(!incoming)return;
          incoming.querySelectorAll('[data-re-item]').forEach(item=>{const href=item.querySelector('a').getAttribute('href');if(known.has(href))return;const group=panels.find(p=>p.dataset.rePanel===item.dataset.reCategory);if(group){known.add(href);group.querySelector('ul').append(item)}});
          indexItems();render();next=incoming.dataset.reNext;
        }catch{return}
      }
    }
    if(root.dataset.reNext)completeCatalog();
  });
})();
